import React, { useEffect } from 'react';

import {
  Card,
  CardClose,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@ais-ui/ui-core';
import { useOnMapPanelExit } from '../Map/MapPanel/useOnMapPanelExit';
import { AtonList } from './AtonList';
import { cn } from '@ais-ui/utils';
import { useLocalization } from '@ais-ui/locale-management';
import { CreatePhysicalAton } from './Mutations/CreatePhysicalAton';
import { CreateVirtualAton } from './Mutations/CreateVirtualAton';
import { useAtonContext } from './AtonContext';
import { EditPhysicalAton } from './Mutations/EditPhysicalAton';
import { EditVirtualAton } from './Mutations/EditVirtualAton';

interface AtonsProps {
  onExit: () => void;
  requiresMap: boolean;
  className: string;
}

const AtonMutationDialogs = () => {
  const {
    showCreatePhysicalAton,
    showCreateVirtualAton,
    showEditPhysicalAton,
    showEditVirtualAton,
  } = useAtonContext();

  return (
    <>
      {showCreatePhysicalAton && <CreatePhysicalAton />}
      {showCreateVirtualAton && <CreateVirtualAton />}
      {showEditPhysicalAton && <EditPhysicalAton />}
      {showEditVirtualAton && <EditVirtualAton />}
    </>
  );
};

export const Atons = React.memo(
  ({ onExit, requiresMap, className }: AtonsProps) => {
    const { messages } = useLocalization();

    return (
      <Card className={cn('flex flex-col', className)}>
        <CardHeader variant="tinted">
          <CardClose onClick={onExit} />
          <div className="space-y-2">
            <CardTitle className="text-lg font-medium text-muted-foreground">
              {messages.atonListTitle}
            </CardTitle>
          </div>
          <CardDescription>{messages.atonListSubtitle}</CardDescription>
        </CardHeader>
        <AtonList requiresMap={requiresMap} />
        {requiresMap && <AtonMutationDialogs></AtonMutationDialogs>}
      </Card>
    );
  },
);

Atons.displayName = 'Atons';
